import { useTranslation } from 'react-i18next';
import { ScanFace, Image as ImageIcon, Share2 } from 'lucide-react';

const stepIcons = [ScanFace, ImageIcon, Share2];

const mockupImages = [
  'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/iuudqgdq_MOCKUP%20APP%20WEB%20MOMENTIA-01.png',
  'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/9bnp4ezf_MOCKUP%20APP%20WEB%20MOMENTIA-02.png',
  'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/ks6plcm1_MOCKUP%20APP%20WEB%20MOMENTIA-03.png',
];

export default function HowItWorks() {
  const { t } = useTranslation();
  const steps = t('home.howItWorks.steps', { returnObjects: true }) || [];

  return (
    <section className="py-24 lg:py-32 relative overflow-hidden" data-testid="home-how-it-works">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[900px] h-[500px] bg-violet-600/8 rounded-full blur-[140px]" />
      </div>
      <div className="container-mi relative">
        <div className="max-w-3xl mb-16">
          <div className="text-xs uppercase tracking-[0.2em] text-violet-300 mb-4">{t('home.howItWorks.eyebrow')}</div>
          <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight leading-tight">
            {t('home.howItWorks.titleLine1')}
            <br />
            <span className="text-white/60">{t('home.howItWorks.titleLine2')}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12 lg:gap-8">
          {steps.map((step, idx) => {
            const Icon = stepIcons[idx];
            return (
              <div key={step.step} className="flex flex-col items-center text-center" data-testid={`how-it-works-step-${idx + 1}`}>
                <div className="relative w-full max-w-[280px]">
                  <img
                    src={mockupImages[idx]}
                    alt={step.title}
                    className="w-full h-auto object-contain drop-shadow-[0_25px_50px_rgba(139,92,246,0.28)]"
                    loading="lazy"
                  />
                </div>

                <div className="mt-8 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-violet-500/10 border border-violet-400/25 flex items-center justify-center text-violet-300">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="text-violet-400 font-display font-bold text-sm tracking-wider">{step.step}</div>
                </div>

                <h3 className="font-display text-xl md:text-2xl font-semibold mt-4 mb-3">{step.title}</h3>
                <p className="text-white/60 leading-relaxed text-[15px] max-w-xs">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
